import Vue from 'vue';
import VueRouter from 'vue-router';
import ConvertPage from  './components/ConvertPage.vue';
import ConvertBase64_Crypt from  './components/ConvertPageBase64_1.vue';
import ConvertBase64_Atob from  './components/ConvertPageBase64_2.vue';
Vue.use(VueRouter)

export default new VueRouter({
    mode:'history',
    routes:[
        {
            path:'/',
            name:'convert',
            component:ConvertPage
        },
        {
            path:'/convert_crypt',
            name:'convert_crypt',
            component:ConvertBase64_Crypt
        },
        {
            path:'/convert_atob',
            name:'convert_atob',
            component:ConvertBase64_Atob
        },
    ]
})